import {
    RichTableColumns,
} from 'app/types/richtable.types'
import ModifiedField from 'app/common/DomainObject/ComponentMapper/ModifiedField'

import {
    ModificationFields,
} from 'app/shared-components/ChangeHistory/ChangeHistory.types'

import columns from 'app/shared-components/ChangeHistory/ChangeHistory.columns'

export default (labelPrefixKeys: string[]): RichTableColumns<ModificationFields>[] => {
    return [
        {
            id: 'fieldName',
            headerProps: {
                children: 'Change',
            },
            mapCellProps: ({
                fieldName,
                subEntityIdentifier,
            }) => {
                const Field = (
                    <ModifiedField
                        value={fieldName}
                        configName="ServiceHistoryChangeHistory"
                        mapCellProps="fieldName"
                        labelPrefixKeys={labelPrefixKeys}
                    />
                )

                return {
                    children: subEntityIdentifier ? (
                        <>
                            {Field}
                            &nbsp;
                            <span>{`(${subEntityIdentifier})`}</span>
                        </>
                    ) : Field,
                }
            },
        },
        ...columns(labelPrefixKeys).slice(1),
    ]
}
